import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableDataGroup, ITableDatsGroupItem, TableDataService } from '../table-data/table-data.service';
import { of, Observable, merge } from 'rxjs';
import { map, catchError, filter } from 'rxjs/operators';

@Component({
  selector: 'app-reports-dashboard',
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.scss']
})
export class ReportsDashboardComponent implements OnInit {

  searchData: string = '';
  /**
   * 
   * @param router 
   * @param route 
   * 
   */
  constructor(private router: Router, private route: ActivatedRoute, private svc: TableDataService) { }

  /**
   * 
   */
  vm$: Observable<IViewModel>;
  

  /**
   * 
   * @param item 
   */
  itemClicked(item: ITableDatsGroupItem) {
    this.router.navigate([ item.code ], { relativeTo: this.route });
  }
  
  /**
   * 
   */
  ngOnInit() {
    const initial$ = of({
      workingText: 'Loading Report List'
    });

    const loader$ = this.svc.getGroups().pipe(
      map(v => {
        const ret: IViewModel = {
          groups: v.groups,
          groupsFiltered: v.groups,
          workingText: undefined,
        };
        return ret;
      }),
      catchError((e, v) => of({ errorText: e.message ? e.message : e}))
    );

    this.vm$ = merge(initial$, loader$);
  }



  doSearch(vm: IViewModel, searchVal: string) {

    if (searchVal.length === 0) {
        vm.groupsFiltered = vm.groups;
        return;
    }

    var index = 0;
    vm.groupsFiltered = [];
    vm.groups.forEach(i => {
      i.items.forEach((t, iidx) => {
        if (t.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
          // first we need find if group exist and add item to the group
          var not_found = true;
          vm.groupsFiltered.forEach((e, eidx) => {
            if (e.title === i.title) {
              vm.groupsFiltered[eidx].items.push(t);
              not_found = false;
            }
          });
          // now if group doesn't exist the add group and item to the group
          if (not_found === true) {
            let grp: ITableDataGroup = {title: i.title, items: [{code: t.code, title: t.title}]};
            vm.groupsFiltered.push(grp);
          }
        }
      });
    });
    
  }
}

/**
 * 
 */
interface IViewModel {
  groups?: ITableDataGroup[],
  groupsFiltered?: ITableDataGroup[]

  workingText?: string;
  errorText?: string;
}
